<div class="appContentsContainer">
  <form
    [formGroup]="maintenanceUser"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        <div *ngIf="operation === 'creacion'" class="pageTitle">
          {{ "maintenanceUsuario.titleCreate" | translate }}
        </div>
        <div *ngIf="operation === 'edicion'" class="pageTitle">
          {{ "maintenanceUsuario.titleEdit" | translate }}
        </div>
        <div *ngIf="operation === 'mod-datos-pers'" class="pageTitle">
          {{ "maintenanceUsuario.titleEditDatPers" | translate }}
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="udId"><label id="usId">ID</label></div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="text"
              formControlName="usId"
              [readonly]="operation === 'edicion' || operation === 'mod-datos-pers'"
              maxlength="16"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usNombre">
              <label id="usNombre">Nombre</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="text"
              formControlName="usNombre"
              maxlength="64"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
            <div class="supIndex" *ngIf="operation === 'mod-datos-pers'">*</div>
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usApellido1">
              <label id="usApellido1">Apellido 1</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="text"
              formControlName="usApellido1"
              maxlength="64"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
            <div class="supIndex" *ngIf="operation === 'mod-datos-pers'">*</div>
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usApellido2">
              <label id="usApellido2">Apellido 2</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="text"
              formControlName="usApellido2"
              maxlength="64"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usEmail">
              <label id="usEmail">E-mail</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="email"
              formControlName="usEmail"
              maxlength="128"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usTelefono">
              <label id="usTelefono">Teléfono</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="text"
              formControlName="usTelefono"
              maxlength="32"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow" *ngIf="operation === 'creacion'">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usPwd">
              <label id="usPwd">Contraseña</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="password"
              formControlName="usPwd"
              autocomplete="new-password"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <div class="row compressedRow" *ngIf="operation === 'creacion'">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usConfirmacion">
              <label id="usConfirmacion">Confirm. contraseña</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              class="inputSearch"
              type="password"
              formControlName="usConfirmacion"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <div
        class="row compressedRow extraHeightRow"
        *ngIf="operation !== 'mod-datos-pers'"
      >
        <div class="itemContainer col colObservaciones">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usObservaciones">
              <label id="usObservaciones"></label>Observaciones
            </div>
          </div>
          <div class="inputContainer">
            <textarea
              formControlName="usObservaciones"
              maxlength="512"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row compressedRow" *ngIf="operation !== 'mod-datos-pers'">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usConcesionario">
              <label id="usConcesionario">Concesionario</label>
            </div>
          </div>
          <div class="inputContainer selectorSearchinput widthMax">
            <input
              class="inputSearch"
              style="padding-right: 20px"
              type="selector"
              formControlName="usConcesionario"
              [ngbTypeahead]="searchConcesionario"
              [resultTemplate]="rtConcesionario"
              [inputFormatter]="formatterConcesionario"
              (selectItem)="maintenanceUser.usConcesionario"
              (focus)="onFocus($event)"
              #instance="ngbTypeahead"
              maxlength="8"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
            <div class="supIndex">*</div>
            <div class="selectorSearchinputIconContainer">
              <em class="fas fa-chevron-down"></em>
            </div>
          </div>
        </div>
      </div>
      <ng-template #rtConcesionario let-r="result" let-t="term">
        <ngb-highlight [result]="r.coId + ' - ' + r.coNombre" [term]="t">
        </ngb-highlight>
      </ng-template>
      <div class="row compressedRow" *ngIf="operation !== 'mod-datos-pers'">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel" for="usPerfil">
              <label id="usPerfil">Perfil</label>
            </div>
          </div>

          <div class="inputContainer selectorSearchinput widthMax">
            <input
              class="inputSearch"
              style="padding-right: 20px"
              type="selector"
              formControlName="usPerfil"
              [ngbTypeahead]="searchPerfil"
              [resultTemplate]="rt"
              [inputFormatter]="formatterPerfil"
              (selectItem)="maintenanceUser.usPerfil"
              (focus)="onFocus($event)"
              (blur)="onBlurPerfil(this)"
              #instance="ngbTypeahead"
              maxlength="8"
              [readonly]="!maintenanceUser.value.usActivo && operation === 'edicion'"
            />
            <div class="supIndex">*</div>
            <div class="selectorSearchinputIconContainer">
              <em class="fas fa-chevron-down"></em>
            </div>
          </div>
        </div>
      </div>
      <ng-container *appPermsRoles="[roles.REVISOR, roles.ADMIN]">
        <div class="row compressedRow" *ngIf="operation !== 'mod-datos-pers'">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel" for="usPerfil">
                <label id="usActivo">Activo</label>
              </div>
            </div>

            <div class="inputContainer selectorSearchinput">
              <input
                class="inputSearch"
                type="checkbox"
                formControlName="usActivo"
                style="cursor: pointer !important"
              />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *appPermsRoles="[roles.REVISOR, roles.ADMIN]">
        <div class="row compressedRow" *ngIf="operation !== 'mod-datos-pers'">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel" for="usBloqueado">
                <label id="usBloqueado">Bloqueado</label>
              </div>
            </div>

            <div class="inputContainer selectorSearchinput">
              <input
                class="inputSearch"
                type="checkbox"
                formControlName="usBloqueado"
                style="cursor: pointer !important"
              />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #rt let-r="result" let-t="term">
        <ngb-highlight [result]="r.peId + ' - ' + r.peDesc" [term]="t">
        </ngb-highlight>
      </ng-template>

      <div class="formGroupButtons detalleFormGroupButtonsFooter">
        <div
          class="formButton"
          *ngIf="operation !== 'mod-datos-pers' && maintenanceUser.pristine"
        >
          <button class="submitButton" type="button" (click)="goList()">
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>

        <div
          class="formButton"
          *ngIf="operation !== 'mod-datos-pers' && !maintenanceUser.pristine"
        >
          <button class="submitButton" type="button" [swal]="confirmSwal">
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>

        <div
          class="formButton"
          *ngIf="operation === 'mod-datos-pers' && maintenanceUser.pristine"
        >
          <button (click)="goPredefinedMailBox()">
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
        </div>

        <div
          class="formButton middleButtonAceptarContainer"
          *ngIf="operation === 'creacion'"
        >
          <div class="middleButtonAceptar formButton" style="padding: 0">
            <button
              type="submit"
              class="submitButton"
              style="margin: auto; width: 100%"
            >
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>

        <div
          class="formButton"
          *ngIf="operation === 'mod-datos-pers' && !maintenanceUser.pristine"
        >
          <button class="submitButton" [swal]="confirmSwalMod">
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
        </div>
        <div
          class="formButton middleButtonAceptarContainer"
          *ngIf="operation === 'edicion'"
        >
          <div class="middleButtonAceptar formButton">
            <button
              *appPermsRoles="[
            roles.ADMIN,
            roles.RHOMOLOG,
            roles.IMPORT,
            roles.REVISOR,
            roles.AAVANZA,
            roles.TECNICO,
            roles.RREGION
          ]"
              type="submit"
              class="submitButton"
            >
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>
        <div
          class="formButton middleButtonAceptarContainer"
          *ngIf="operation === 'mod-datos-pers'"
        >
          <div class="middleButtonAceptar formButton">
            <button
              type="submit"
              class="submitButton"
              *appPermsRoles="[
            roles.ADMIN,
            roles.RHOMOLOG,
            roles.IMPORT,
            roles.REVISOR,
            roles.AAVANZA,
            roles.TECNICO,
            roles.RREGION
          ]"
            >
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>
      </div>
      <swal
        #confirmSwal
        html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
        icon="warning"
        [showCancelButton]="true"
        [swalOptions]="{
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          allowEscapeKey: false,
          allowOutsideClick: false
        }"
        [focusCancel]="true"
        (confirm)="goList()"
      >
      </swal>
      <swal
        #confirmSwalMod
        html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
        icon="warning"
        [showCancelButton]="true"
        [swalOptions]="{
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          allowEscapeKey: false,
          allowOutsideClick: false
        }"
        [focusCancel]="true"
        (confirm)="goPredefinedMailBox()"
      >
      </swal>
    </div>
  </form>
  <form></form>
</div>
